export const projectHasNextSibling = (currentComponent, tagName) => {
    // Todo : only for storybook
    if (window.nwc == null) {
        return (
            currentComponent.nextElementSibling != null &&
            currentComponent.nextElementSibling.tagName.toLowerCase() === tagName
        )
    }
    // For production
    let currentIndex = -1
    const project = window.nwc.projects.find(project => {
        currentIndex = project.components.findIndex(
            component => component.uuid === currentComponent.id
        )
        return currentIndex !== -1
    })
    return (
        project &&
        project.components.find(
            (component, index) => component.module === tagName && index === currentIndex + 1
        ) != null
    )
}
